import gql from 'graphql-tag';

export const CONFLICT_APPLICATION = gql`
  query ($department: String!, $programme: PROGRAMME!, $entryYear: String!) {
    hasConflictApplication(
      department: $department
      programme: $programme
      entryYear: $entryYear
    )
  }
`;
